import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

import aseguradora from './aseguradora.js';
import catalogos from './catalogos.js';
import constructor from './constructor.js';
import siniestro from './siniestro.js';
import ajustePoliza from './ajustePoliza.js';
import informe from './informe.js';
import seguridad from './seguridad.js';
import recaudacion from './recaudacion.js';

window._ = require('lodash');

Vue.use(VueRouter)

const home = [
  {
    path: '/',
    name: 'Home',
    component: Home
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes:[
    {
      path: '/',
      name: 'LoginView',
      component: () => import('../views/LoginView.vue')
    },
    {
      path: '/main',
      component: () => import('../views/layout/MainView.vue'),
      children: _.concat(home,aseguradora,constructor,catalogos,ajustePoliza,siniestro,informe,seguridad,recaudacion)
    },
    {
      path: '/main',
      component: () => import('../views/layout/full-page/FullPageView.vue'),
      children: [
        {
          path: '/logout',
          name: 'LoginView',
          component: () => import('../views/LoginView.vue')
        },
        {
          path: '/not-found',
          name: 'NotFoundView',
          component: () => import('../views/NotFoundView.vue'),
        },
      ]
    },
  ]
});

router.beforeEach((to,from,next) =>{
  var listOpcionDefault = ['/','/main','/not-found','/logout','/informacion/usuario'];
  var menuFake = JSON.parse(localStorage.getItem('menu'));
  var c = _.includes(listOpcionDefault,to.path) ? 1 : 0;
  
  _.forEach(menuFake,(v)=>{
    c+= !_.isUndefined(_.find(v.items,{'path':to.path})) ? 1 : 0;
  });

  if(c > 0)
    next();
  else
    next({path: '/not-found'})
})
export default router
